<template>
    <div class="form_message_space" :class="showClass">
        <div class="form_message" :class="[message.type]" ref="messageSuccess" v-if="message">
            <div class="form_message_icon">
                <span class="material-icons-outlined">info</span>
            </div>
            <div class="form_message_text">
                <p>{{ message.title }}</p>
                <div class="msg_description" v-html="message.subtitle"></div>
            </div>
            <div class="form_message_close" @click="hideMessage()">
                <span class="material-icons-outlined">close</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['message'],
    data() {
        return {
            errorMessage: false,
            successMessage: true,
            showClass: "show"
        }
    },
    methods: {
        hideMessage() {
            this.showClass = "close";
            setTimeout(() => {
                this.$emit('close');
            }, 400);
        }
    },
    watch: {
        message(val){
            if(val != null){
                setTimeout(() => {
                    this.showClass = "show";
                }, 500);
                
            }
        }
    },
}
</script>